<template>
  <div class="border-b flex items-center py-2 overflow-x-hidden hover:bg-slate-50" v-bind="$attrs">
    <div class="grow flex">
      <div class="w-12 text-center cursor-pointer" @click="toggleOpen">
        <i class="fa-solid fa-angle-down"></i>
      </div>
      [{{ item.menuPosition }}]
      <div class="w-12 text-center">
        <i v-if="item.icon" :class="item.icon" class="mx-2 w-8"></i>
      </div>
      {{ item.name }}
    </div>
    <div class="w-3/12">{{ item.screenRoute }}</div>

    <div class="flex w-24 shrink-0 items-center justify-center gap-1">
      <Tooltip label="Editar">
        <IconButton icon="fa-solid fa-pen" aria-label="Editar" @click="emit('edit', item.id)" v-can="'screen.edit'" />
      </Tooltip>
      <Tooltip label="Excluir">
        <IconButton icon="fa-solid fa-trash" aria-label="Excluir" @click="emit('removeConfirm', item)" v-can="'screen.delete'" />
      </Tooltip>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  item: Object,
  modelValue: Boolean,
})

const emit = defineEmits(['edit', 'removeConfirm', 'emitSelectedItem', 'update:modelValue'])

const opened = ref(false)

const toggleOpen = () => {
  opened.value = !opened.value
  emit('update:modelValue', opened.value)
}
</script>
